import styled from 'styled-components';
import { MaxWidth } from '../../common/base';

const CtaWrapper = styled.div`
  background-color: ${({ theme: { colors } }) => colors.gray.light};
  position: relative;
  white-space: pre-wrap;
  &:before {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50%;
    content: '';
    background-color: ${({ theme: { colors } }) => colors.primary.secondary};
  }
`;

const CtaBox = styled.div`
  background-color: ${({ theme: { colors } }) => colors.light.primary};
  padding: 80px 100px;
  border-radius: 4px;
  ${MaxWidth.md`
    padding: 80px 40px;
  `}
  ${MaxWidth.sm`
    padding: 40px 24px;
  `}
`;

const CtaBoxButton = styled.div`
  text-align: center;
  ${MaxWidth.md`
    text-align: left;
  `}
`;

export { CtaWrapper, CtaBox, CtaBoxButton };
